import { VFC } from 'react'
import { useMasterData } from 'src/api/masterData'
import { LIGHT_BLUB } from 'src/assets/images'
import { LoginUser, Needs } from 'src/models/User'
import { _needs_form_light_blub, mediumGray } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { ProfileForm } from '../formComponents'
import { NeedsSelect } from '../formComponents/NeedSelect'
import { ProfileEditorWrapper } from '../ProfileLayout'

type NeedsFormProps = {
  user: LoginUser
  submit: (needs: Needs) => Promise<any>
}

export const NeedsForm: VFC<NeedsFormProps> = ({ user, submit }) => {
  const { data } = useMasterData()
  return (
    <ProfileEditorWrapper user={user} currentPath="ニーズの編集">
      <ProfileForm
        title="ニーズの編集"
        description={
          'あなたの今抱えている悩みやニーズに近いものを３個以上選択してください'
        }
        user={user}
        propertyKey="needs"
        submit={submit}
        displayTipsLink={false}
      >
        <NeedsLightBlubDivComponent />
        <NeedsSelect id="items" items={data?.needs || []} />
      </ProfileForm>
    </ProfileEditorWrapper>
  )
}

export const NeedsLightBlubDivComponent = () => (
  <LightBlubDiv>
    <img src={LIGHT_BLUB} alt="" />
    「ニーズ」とは、あなたが解決したい課題や必要としているサービス・サポートを指します。
    <br />
    例えば「特定の人材を採用したい」「自社強化をしたい」など、あなたが現在求めているものや実現したいことを選んでいただくことで、より適切なマッチングが可能になります。
  </LightBlubDiv>
)

const LightBlubDiv = styled.div`
  background-color: ${_needs_form_light_blub};
  border-radius: 8px;
  padding: 20px;
  margin: 20px 20px;
  display: flex;
  align-items: center;
  font-weight: ${fontWeightBold};
  font-size: 12px;
  color: ${mediumGray};

  img {
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }
`
